import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PLAN_INFO, PLAN_FEATURES, userPlan } from "@/lib/plans";
import { Check, X, Crown } from "lucide-react";

const Cell = ({ v }) => (v === true ? <Check className="w-5 h-5 text-emerald-600 mx-auto"/> : v === false ? <X className="w-5 h-5 text-slate-300 mx-auto"/> : <span className="text-sm">{v}</span>);
const KEYS = ["free", "standard", "professional"];

const PlanHead = ({ k, current }) => {
  const p = PLAN_INFO[k];
  return (
    <div className={`rounded-2xl p-6 h-full flex flex-col ${p.best ? "bg-navy text-white ring-2 ring-gold" : "card-premium"}`} data-testid={`plan-col-${k}`}>
      {p.best && <span className="chip-gold self-start mb-2"><Crown className="w-3 h-3"/>Consigliato</span>}
      <div className="font-display text-2xl font-bold">{p.name}</div>
      <div className="mt-3"><span className="font-display text-4xl font-bold text-gold">{p.price}</span> <span className={p.best ? "text-slate-300" : "text-slate-500"}>{p.per}</span></div>
      <p className={`text-xs mt-1 ${p.best ? "text-slate-300" : "text-slate-500"}`}>{p.note}{k !== "free" && " \u00b7 IVA esclusa \u00b7 7 giorni di prova"}</p>
      <div className="mt-auto pt-5">
        {current === k ? <span className="btn-pill-outline w-full justify-center opacity-70" data-testid={`plan-current-${k}`}>Il tuo piano</span>
          : k === "free" ? <Link to="/registrati" className="btn-pill-outline w-full justify-center" data-testid="plan-cta-free">Iscriviti gratis</Link>
          : <Link to={`/abbonamento?plan=${k}`} className="btn-pill-gold w-full justify-center" data-testid={`plan-cta-${k}`}>{current && current !== "free" ? "Passa a questo piano" : "Scegli " + PLAN_INFO[k].name}</Link>}
      </div>
    </div>
  );
};

export default function Plans() {
  const { user } = useAuth();
  const current = user && ["artist", "supplier"].includes(user.role) ? userPlan(user) : null;
  return (
    <div className="max-w-6xl mx-auto px-6 py-12" data-testid="plans-page">
      <span className="overline text-gold">Abbonamenti per Artisti e Fornitori</span>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-2">Scegli il piano giusto per te</h1>
      <p className="text-slate-600 mt-3 max-w-2xl">Nessuna commissione sulle prenotazioni: concordi il compenso direttamente con il committente. Puoi cambiare piano in qualsiasi momento dalla Dashboard.</p>
      <div className="grid md:grid-cols-3 gap-5 mt-10">{KEYS.map((k) => <PlanHead key={k} k={k} current={current}/>)}</div>
      <div className="card-premium mt-10 overflow-x-auto" data-testid="plans-compare">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-navy text-white"><tr><th className="text-left px-5 py-4">Servizi inclusi</th>{KEYS.map((k) => <th key={k} className={`px-5 py-4 text-center ${current === k ? "text-gold" : ""}`}>{PLAN_INFO[k].name}</th>)}</tr></thead>
          <tbody>{PLAN_FEATURES.map(([f, ...vals]) => (
            <tr key={f} className="border-t border-slate-100"><td className="px-5 py-3">{f}</td>{vals.map((v, i) => <td key={i} className={`px-5 py-3 text-center ${KEYS[i] === "professional" ? "bg-gold/5 font-semibold" : ""}`}><Cell v={v}/></td>)}</tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
